<script setup lang="ts">
import CenterChildrenWrapper from '@components/layout-wrapper/center-children-wrapper.vue';
import Text from '@components/text.vue';
import Button from '@components/buttons/button.vue';
import { type Component, onMounted } from 'vue';
import mobileDetectStore from '@src/application/store/mobile-detect-store.js';
import Separator from '@components/separator.vue';

const props = withDefaults(
    defineProps<{
        component?: string|Component|null,
        resolveListener: string,
        message?: string|null,
        resolveText: string,
        rejectText: string|false,
        props?: object,
    }>(), {
        component: null,
        message: null,
        props: () => {
            return {};
        },
    },
);

onMounted(() => {
    if (mobileDetectStore.isMobile.data) {
        return;
    }

    document.addEventListener('keydown', onKeyDown);
});

const emits = defineEmits<{
    [eventName: string]: any,
    reject: [],
}>();

function onKeyDown(e: KeyboardEvent) {
    document.removeEventListener('keydown', onKeyDown);
    if (e.key === 'Enter') {
        resolveModal();
    }
    if (e.key === 'Escape') {
        rejectModal();
    }
}

function resolveModal(returnValue?: any) {
    if (returnValue === undefined) {
        emits(props.resolveListener);
    } else {
        emits(props.resolveListener, returnValue);
    }
}

function rejectModal() {
    emits('reject');
}
</script>

<template>
    <div :class="$style.modal_approve">
        <component
            :is="component"
            v-if="component !== null"
            v-bind="props.props"
            @[resolveListener]="
                // @ts-ignore
                resolveModal($event)
            "
        />
        <Text
            v-if="message !== null"
            :class="$style.message"
            alignment="center"
            line-spacing="1"
            v-html="message.replace(/\n/g, '<br/>')"
        />
        <Separator :border="false" gap="1"/>
        <CenterChildrenWrapper>
            <Button :class="$style.button" @click="resolveModal">{{ resolveText }}</Button>
            <Button v-if="rejectText" :class="$style.button" @click="rejectModal">{{ rejectText }}</Button>
        </CenterChildrenWrapper>
    </div>
</template>

<style lang="scss" module>
    .modal_approve {
        .message {
            font-size: 1.1em;
        }
        .button {
            min-width: 7em;
        }
    }
</style>
